<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <ng-container>
        <div class="main-content">
            <div class="main-heading">
                <h1>Product Status Dashboard</h1>
            </div>
            <div class="text-muted" style="font-weight: bold;">Total Records: {{ totalRecords }}</div>
            <div style="overflow-x: auto;">
                <p-table #table [value]="filteredData" [paginator]="true" [rows]="10" [loading]="loading"
                    [globalFilterFields]="['NDA number', 'Brand Name/Proprietary Name', 'Route of Administration', 'Dosage forms', 'Nature of Dosage form']"
                    class="p-datatable-gridlines">

                    <ng-template pTemplate="caption">
                        <div class="d-flex justify-content-between align-items-center flex-wrap gap-3"
                            style="width: 100%;">

                            <div class="d-flex align-items-center gap-2" style="min-width: 250px;">
                                <p-dropdown class="status-dropdown" [options]="statusOptions"
                                    [(ngModel)]="selectedStatus" optionLabel="label" optionValue="value"
                                    placeholder="Select Status" (onChange)="onStatusChange()" appendTo="body"
                                    styleClass="p-dropdown-sm w-100">
                                </p-dropdown>

                                <p-dropdown [options]="ROADropdownOptions" [(ngModel)]="selectedROA" optionLabel="label"
                                    optionValue="value" placeholder="Select ROA" (onChange)="onRoaChange()"
                                    appendTo="body" styleClass="p-dropdown-sm w-100">
                                </p-dropdown>
                            </div>

                            <div class="d-flex ms-auto" style="min-width: 250px;">
                                <input type="text" pInputText placeholder="Search all fields..."
                                    (input)="table.filterGlobal($event.target.value, 'contains')"
                                    class="form-control w-100">
                            </div>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Route of Administration</th>
                            <th>Dosage Forms</th>
                            <th>Nature of Dosage Form</th>
                            <th *ngIf="['Parked', 'Discontinued', 'Review', 'Ready to Live'].includes(selectedStatus)">
                                Comments</th>
                            <th *ngIf="['Parked', 'Discontinued', 'Review'].includes(selectedStatus)">
                                Actions
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row['NDA number'] }}</td>
                            <td>{{ row['Brand Name/Proprietary Name'] }}</td>
                            <td>{{ row['Route of Administration'] }}</td>
                            <td>{{ row['Dosage forms'] }}</td>
                            <td>{{ row['Nature of Dosage form'] }}</td>
                            <td *ngIf="['Parked', 'Discontinued', 'Review', 'Ready to Live'].includes(selectedStatus)">
                                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-text"
                                    title="View Comment" (click)="openDialog('view', row)"></button>
                                <!-- <button pButton icon="pi pi-plus" class="p-button-rounded p-button-text"
                                    title="Add Comment" (click)="openDialog('add', row)"></button> -->
                                <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text"
                                    title="Edit Comment" (click)="openDialog('edit', row)"></button>
                            </td>
                            <td *ngIf="['Parked', 'Discontinued'].includes(selectedStatus)">
                                <button pButton label="Move to Review"
                                    style="background-color:#28a745; color:white; border:none; padding:6px 12px; border-radius:6px; font-size:13px; margin-right:8px; cursor:pointer;"
                                    (click)="openStatusChangeDialog(row, 'Review')">
                                </button>

                                <button pButton label="Move to Discontinued"
                                    style="background-color:#dc3545; color:white; border:none; padding:6px 12px; border-radius:6px; font-size:13px; margin-right:8px; cursor:pointer;"
                                    (click)="openStatusChangeDialog(row, 'Discontinued')">
                                </button>
                            </td>
                            <td *ngIf="selectedStatus === 'Review'">
                                <button pButton label="Move to Parked"
                                    style="background-color:#ff9800; color:white; border:none; padding:6px 12px; border-radius:6px; font-size:13px; margin-right:8px; cursor:pointer;"
                                    (click)="openStatusChangeDialog(row, 'Parked')">
                                </button>

                                <button pButton label="Move to Discontinued"
                                    style="background-color:#f44336; color:white; border:none; padding:6px 12px; border-radius:6px; font-size:13px; cursor:pointer;"
                                    (click)="openStatusChangeDialog(row, 'Discontinued')">
                                </button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-dialog header="{{ dialogHeader }}" [(visible)]="displayDialog" [modal]="true"
                    [style]="{width: '400px'}" [closable]="true" [dismissableMask]="true">

                    <div class="p-fluid">
                        <div class="p-field">
                            <label for="commentInput">Comment</label>
                            <textarea id="commentInput" rows="5" class="form-control" [(ngModel)]="selectedComment"
                                [readonly]="dialogMode === 'view'"></textarea>
                        </div>
                    </div>

                    <ng-template pTemplate="footer">
                        <button *ngIf="dialogMode !== 'view'" pButton label="Save" icon="pi pi-check"
                            (click)="saveComment()" class="p-button-sm"></button>
                        <button pButton label="Close" icon="pi pi-times" (click)="displayDialog = false"
                            class="p-button-secondary p-button-sm"></button>
                    </ng-template>
                </p-dialog>

            </div>
        </div>
    </ng-container>
</div>